/* eslint-disable */
import GraphQL from '../../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables = GraphQL.Exact<{
  cases: ReadonlyArray<GraphQL.IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase> | GraphQL.IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase;
  issueName: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation = { readonly __typename?: 'Mutation', readonly IgnorePageIssueCasesOfImageIssuesOnWholeWebsite: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly ping: string } } };

export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables = GraphQL.Exact<{
  cases: ReadonlyArray<GraphQL.IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase> | GraphQL.IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase;
  issueName: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation = { readonly __typename?: 'Mutation', readonly IgnorePageIssueCasesOfLinkIssuesOnWholeWebsite: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly ping: string } } };

export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables = GraphQL.Exact<{
  cases: ReadonlyArray<GraphQL.IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase> | GraphQL.IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase;
  issueName: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation = { readonly __typename?: 'Mutation', readonly UnignorePageIssueCasesOfImageIssuesOnWholeWebsite: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly ping: string } } };

export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables = GraphQL.Exact<{
  cases: ReadonlyArray<GraphQL.IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase> | GraphQL.IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase;
  issueName: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation = { readonly __typename?: 'Mutation', readonly UnignorePageIssueCasesOfLinkIssuesOnWholeWebsite: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly ping: string } } };


export const IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteDocument = gql`
    mutation IgnorePageIssueCasesOfImageIssuesOnWholeWebsite($cases: [IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase!]!, $issueName: String!, $websiteId: WebsiteId!) {
  IgnorePageIssueCasesOfImageIssuesOnWholeWebsite(
    cases: $cases
    issueName: $issueName
    websiteId: $websiteId
  ) {
    query {
      ping
    }
  }
}
    `;
export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationFn = Apollo.MutationFunction<IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>;

/**
 * __useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation__
 *
 * To run a mutation, you first call `useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, { data, loading, error }] = useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation({
 *   variables: {
 *      cases: // value for 'cases'
 *      issueName: // value for 'issueName'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>(IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteDocument, options);
      }
export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationHookResult = ReturnType<typeof useIgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation>;
export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationResult = Apollo.MutationResult<IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation>;
export type IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationOptions = Apollo.BaseMutationOptions<IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>;
export const IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteDocument = gql`
    mutation IgnorePageIssueCasesOfLinkIssuesOnWholeWebsite($cases: [IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase!]!, $issueName: String!, $websiteId: WebsiteId!) {
  IgnorePageIssueCasesOfLinkIssuesOnWholeWebsite(
    cases: $cases
    issueName: $issueName
    websiteId: $websiteId
  ) {
    query {
      ping
    }
  }
}
    `;
export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationFn = Apollo.MutationFunction<IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>;

/**
 * __useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation__
 *
 * To run a mutation, you first call `useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, { data, loading, error }] = useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation({
 *   variables: {
 *      cases: // value for 'cases'
 *      issueName: // value for 'issueName'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>(IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteDocument, options);
      }
export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationHookResult = ReturnType<typeof useIgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation>;
export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationResult = Apollo.MutationResult<IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation>;
export type IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationOptions = Apollo.BaseMutationOptions<IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>;
export const UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteDocument = gql`
    mutation UnignorePageIssueCasesOfImageIssuesOnWholeWebsite($cases: [IgnorePageIssueCasesOfImageIssuesOnWholeWebsiteCase!]!, $issueName: String!, $websiteId: WebsiteId!) {
  UnignorePageIssueCasesOfImageIssuesOnWholeWebsite(
    cases: $cases
    issueName: $issueName
    websiteId: $websiteId
  ) {
    query {
      ping
    }
  }
}
    `;
export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationFn = Apollo.MutationFunction<UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>;

/**
 * __useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation__
 *
 * To run a mutation, you first call `useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, { data, loading, error }] = useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation({
 *   variables: {
 *      cases: // value for 'cases'
 *      issueName: // value for 'issueName'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>(UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteDocument, options);
      }
export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationHookResult = ReturnType<typeof useUnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation>;
export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationResult = Apollo.MutationResult<UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation>;
export type UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationOptions = Apollo.BaseMutationOptions<UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfImageIssuesOnWholeWebsiteMutationVariables>;
export const UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteDocument = gql`
    mutation UnignorePageIssueCasesOfLinkIssuesOnWholeWebsite($cases: [IgnorePageIssueCasesOfLinkIssuesOnWholeWebsiteCase!]!, $issueName: String!, $websiteId: WebsiteId!) {
  UnignorePageIssueCasesOfLinkIssuesOnWholeWebsite(
    cases: $cases
    issueName: $issueName
    websiteId: $websiteId
  ) {
    query {
      ping
    }
  }
}
    `;
export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationFn = Apollo.MutationFunction<UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>;

/**
 * __useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation__
 *
 * To run a mutation, you first call `useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, { data, loading, error }] = useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation({
 *   variables: {
 *      cases: // value for 'cases'
 *      issueName: // value for 'issueName'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>(UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteDocument, options);
      }
export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationHookResult = ReturnType<typeof useUnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation>;
export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationResult = Apollo.MutationResult<UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation>;
export type UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationOptions = Apollo.BaseMutationOptions<UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutation, UnignorePageIssueCasesOfLinkIssuesOnWholeWebsiteMutationVariables>;